import React from 'react';
import { Container } from 'react-bootstrap';

import Icon from 'src/components/Icon';
import style from './style.module.scss';

const Footer: React.FunctionComponent = () => {
  return (
    <footer className={`${style.footer} bg-light`}>
      <Container fluid className="text-black-50">
        <small className="text-muted ">v{process.env.REACT_APP_VERSION}</small>
        <small className="float-right">
          Copyright <Icon icon="copyright" size="xs" className="align-middle" /> 2021 Bludot Technologies Inc.
        </small>
      </Container>
    </footer>
  );
};

export default Footer;
